import React, { Component } from "react";
import "./Form.css";

export default class Form extends Component {
  state = {
    input: ""
  };
  render() {
    return (
      <form
        onSubmit={e => {
          e.preventDefault();
          this.props.submit(this.state.input);
        }}
      >
        <div>
          <div className="form">
            <input
              type="text"
              value={this.input}
              onChange={e => this.setState({ input: e.target.value })}
            />
            <button className="ui button" type="submit">
              Submit
            </button>
          </div>
          <span className="link skip" onClick={() => this.props.submit("")}>
            Skip
          </span>
        </div>
      </form>
    );
  }
}
